module.exports = __webpack_public_path__ + "static/bg-zoom-efbf9dd4d04c199b0d85b149abfe5a8d.jpg";